import React from "react";
import { BrowserRouter } from "react-router-dom";
// import "antd/dist/antd.less";
import "./styles/global.less";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import GlobalStyle from "./styles/global";

import Routes from "./routes";

import AppProvider from "./hooks/index";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "pt",
    fallbackLng: "pt",

    interpolation: {
      escapeValue: false,
    },
  });

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppProvider>
        <Routes />
      </AppProvider>

      <GlobalStyle />
    </BrowserRouter>
  );
};

export default App;
